// extracted by mini-css-extract-plugin
export default {"container":"quotes_container__RzcvW","quote":"quotes_quote__cx3Gb","quoter":"quotes_quoter__Vfmu3","absolute_md":"quotes_absolute_md__GSCfG"};